//
import { RTable } from '@/components/reusable_components/next'

//
import PosCustomerReceivablePaymentFilters from '@/views/POS/PosCustomerReceivablePayment/filters'
import PosCustomerReceivablePaymentHeaders from '@/views/POS/PosCustomerReceivablePayment/headers'
import PosCustomerReceivablePaymentService from '@/services/api/POS/PosCustomerReceivablePayment'

//
export default {
  components: {
    RTable,
  },
  computed: {

    /**
     * 
     */
    tableProps() {
      return {
        filters: PosCustomerReceivablePaymentFilters.toList(),
        headers: PosCustomerReceivablePaymentHeaders.toList(),
        service: PosCustomerReceivablePaymentService.toList(),
      }
    }
  },
  methods: {

    /**
     * 
     */
    onError(error) {
      this.$toast.error(error.error || error.message)
    },

    /**
     * 
     */
    onSuccess(event) {
      this.$toast.success(event.message)      
    },

    /**
     * 
     */
    onDelete(event) {
      this.$toast.confirm('¿Confirma la eliminación del pago seleccionado?', this.$toaster(this, () => this.toDelete(event.item))) 
    },

    /**
     * 
     */
    toDelete(posCustomerReceivablePayment) {
      PosCustomerReceivablePaymentService.delete(posCustomerReceivablePayment).then(this.onSuccess).catch(this.onError)
    },
  },
  mounted() {
    this.setTitle('Pagos de deuda de clientes')
  }
}